/**
 * 無事
 */
export const SAFETY = 1;

/**
 * 軽傷
 */
export const MINOR_INJURY = 2;

/**
 * 重傷
 */
export const SERIOUS_INJURY = 3;
